import React from 'react'
import Tooltip from '@mui/material/Tooltip'

const CleanTooltip = ({ children, ...props }) => {
    const [open, setOpen] = React.useState(false)

    return (
        <Tooltip
            {...props}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            disableInteractive
            slotProps={{
                popper: {
                    style: { zIndex: 1250 },
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, -14],
                            },
                        },
                    ],
                },
            }}
        >
            {React.cloneElement(children, {
                onClick: (event) => {
                    setOpen(false)
                    if (children.props.onClick) { children.props.onClick(event) }
                },
            })}
        </Tooltip>
    )
}

export default CleanTooltip
